import { Paper, Stack, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { ChangeEvent, useCallback } from "react";
import { useUpdatePharmacyMutation } from "src/api/services/pharmacyApi";
import { Pharmacy } from "src/api/types";
import StyledSwitch from "src/components/StyledSwitch";
import BasicPopover from "src/shared/BasicPopover";
import PharmacyStates from "../PharmacyStates";

interface Props {
  pharmacy: Pharmacy;
}

const PharmacyToggle = ({ pharmacy }: Props) => {
  const [updatePharmacy] = useUpdatePharmacyMutation();

  const handleToggle = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      updatePharmacy({
        id: pharmacy.id,
        body: {
          active: event.target.checked,
        },
      });
    },
    [pharmacy.id, updatePharmacy],
  );

  return (
    <Grid2 size={3}>
      <Paper
        elevation={5}
        p={1}
        component={Stack}
        direction="row"
        alignItems="center"
        role="group"
        justifyContent="space-between"
        sx={{
          borderRadius: "8px",
        }}
      >
        <Stack direction="row" alignItems="center" gap={0}>
          <BasicPopover>
            <PharmacyStates
              pharmacyId={pharmacy.id}
              disabled={!pharmacy.active}
            />
          </BasicPopover>
          <Typography variant="h6" id={`label-${pharmacy.id}`}>
            {pharmacy.name}
          </Typography>
        </Stack>

        <StyledSwitch
          slotProps={{
            input: { "aria-labelledby": `label-${pharmacy.id}` },
          }}
          checked={pharmacy.active}
          onChange={handleToggle}
        />
      </Paper>
    </Grid2>
  );
};

export default PharmacyToggle;
